// extracted by mini-css-extract-plugin
export default {"title":"EditPartialDisruptionMessagePage_title__pFX1S"};